"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataStream = require("./lib/DataStream");
exports.MSGReader = require("./lib/msg.reader");